export function formatAddress(
  address: string,
  { start, end }: { readonly start: number; readonly end: number } = { start: 5, end: 4 },
): string {
  return `${address.slice(0, start)}...${address.slice(-end)}`;
}
